/*
 * @Author: Teemo Ding
 * @Date: 2021-11-12 15:24:30
 * @LastEditTime: 2023-03-27 08:34:41
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Delivery/index.tsx
 */
import { ModalFooter } from '@/src/components/Antd';
import { getCourierShow } from '@/src/pages/Settings/Logistics/CourierAccount/tools';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import {
  markDelivered,
  printPackingSlip,
  printParcelCourierLabel,
} from 'src/request/order';
import { msg } from 'src/tools/message';
import { IFulfillmentStatus } from 'src/types/common/order';
import { getMaxTimeline } from '../../tools';
//import css from './css.module.less';
import Category from '../Components/Category';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { handleOnFormatStoreTimeAndDateWithTimezone } from 'src/tools/tools';

const Delivery = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    modalOp,
    disabled,
    data,
    orderNo,
    onUpdate,
    onUndo,
    disablePrint,
    decimalPosition,
    taxIncluded,
  } = props;
  const {
    setShowModal,
    setModalTitle,
    setModalContent, //onModalCancel
    setWidth,
  } = modalOp;

  const MarkAsDelivered = (parcelUuid) => {
    markDelivered(parcelUuid).then((res) => {
      onUpdate(res);
      msg.success(
        getI18n('allOrders.orderDetail.delivery_markasdelivered_msgsuccess'),
      );
      setShowModal(false);
    });
  };
  const fulfillmentStatus = {
    [IFulfillmentStatus.ERROR]: getI18n(
      'allOrders.orderDetail.delivery_fulfillmentstatus_error',
    ),
    [IFulfillmentStatus.DELIVERING]: getI18n(
      'allOrders.orderDetail.delivery_fulfillmentstatus_delivering',
    ),
    [IFulfillmentStatus.DELIVERED]: getI18n(
      'allOrders.orderlist.config_tabs_Delivered',
    ),
    [IFulfillmentStatus.READY_TO_COLLECT]: getI18n(
      'allOrders.orderDetail.delivery_fulfillmentstatus_READY_TO_COLLECT',
    ),
  };

  return (
    <Category
      decimalPosition={decimalPosition}
      taxIncluded={taxIncluded}
      title={getI18n('allOrders.orderDetail.delivery_return_catogory_title')}
      data={data.map((i) => {
        const image = get(i, 'images.0.url');
        const pickedDate = get(i, 'pickedDate', null);
        const packedDate = get(i, 'packedDate', null);
        const shippedData = get(i, 'shippedDate', null);
        const courierType = get(i, 'courierType', null);
        const timelines = get(i, 'timelines', null);
        const status = get(i, 'status', null);
        const waybillNo = get(i, 'waybillNo', null);
        const pickDate = handleOnFormatStoreTimeAndDateWithTimezone(pickedDate);
        const packDate = handleOnFormatStoreTimeAndDateWithTimezone(packedDate);
        const shipdData = shippedData
          ? handleOnFormatStoreTimeAndDateWithTimezone(shippedData)
          : '';
        const parcelNo = get(i, 'parcelNo');
        const uuid = get(i, 'uuid');
        return {
          uuid,
          image,
          sku: `${orderNo}-${parcelNo}`,
          options: [
            {
              title: getI18n(
                'allOrders.orderDetail.delivery_return_catogory_options_pickedtitle',
              ),
              content: pickDate || '-',
            },
            {
              title: getI18n(
                'allOrders.orderDetail.delivery_return_catogory_options_couriertitle',
              ),
              content: getCourierShow({
                type: courierType,
                qsfAccount: { location: '' },
              }),
            },
            {
              title: getI18n(
                'allOrders.orderDetail.delivery_return_catogory_options_packedtitle',
              ),
              content: packDate,
            },
            {
              title: getI18n(
                'allOrders.orderDetail.delivery_return_catogory_options_waybilltitle',
              ),
              content: waybillNo ? `#${waybillNo}` : '',
            },
            {
              title: getI18n(
                'allOrders.orderDetail.delivery_return_catogory_options_shippedtitle',
              ),
              content: shipdData,
            },
            {
              title: getI18n(
                'allOrders.orderDetail.delivery_return_catogory_options_statustitle',
              ),
              content: (
                <div className={css.deliverySatus}>
                  <p>{fulfillmentStatus[status]}</p>
                  <span className={css.time}>
                    {getMaxTimeline(timelines, status)}
                  </span>
                  {/* <span className={css.timeline}>
                    {getI18n(
                      'allOrders.orderDetail.delivery_return_catogory_options_timelinecontent',
                    )}
                  </span> */}
                </div>
              ),
            },
          ],
          btns: [
            ...(status !== IFulfillmentStatus.DELIVERED
              ? [
                  {
                    text: getI18n(
                      'allOrders.orderDetail.delivery_return_catogory_btns_Couriertext',
                    ),
                    disabled: disablePrint,
                    onClick: () => printParcelCourierLabel(uuid),
                  },
                ]
              : []),
            {
              text: getI18n(
                'allOrders.orderDetail.delivery_return_catogory_btns_Packingtext',
              ),
              disabled: disablePrint,
              onClick: () => printPackingSlip(uuid),
            },
          ],
          ...(!disabled && {
            dropOptions: [
              ...//status !== IFulfillmentStatus.ERROR &&
              (status !== IFulfillmentStatus.DELIVERED
                ? [
                    {
                      label: getI18n(
                        'allOrders.orderDetail.delivery_return_catogory_dropoptions_undolabel',
                      ),
                      onClick: () => {
                        onUndo(uuid, (res) => {
                          onUpdate(res);
                          msg.success('Order has been updated');
                          console.log('undo', res);
                        });
                      },
                    },
                    {
                      label: getI18n(
                        'allOrders.orderDetail.delivery_return_catogory_btns_Couriertext',
                      ),
                      disabled: disablePrint,
                      onClick: () => printParcelCourierLabel(uuid),
                    },
                  ]
                : [
                    {
                      label: getI18n(
                        'allOrders.orderDetail.delivery_return_catogory_btns_Couriertext',
                      ),
                      disabled: disablePrint,
                      onClick: () => printParcelCourierLabel(uuid),
                    },
                  ]),
              ...(status !== IFulfillmentStatus.DELIVERED
                ? [
                    {
                      label: getI18n(
                        'allOrders.orderDetail.delivery_return_catogory_dropoptions_marklabel',
                      ),
                      onClick: () => {
                        setWidth(500);
                        setShowModal(true);
                        setModalTitle(
                          getI18n(
                            'allOrders.orderDetail.delivery_return_catogory_dropoptions_marklabel',
                          ),
                        );
                        setModalContent(
                          <Fragment>
                            <p className={css.deliveredModal}>
                              {getI18n(
                                'allOrders.orderDetail.delivery_return_catogory_dropoptions_fragment',
                              )}
                            </p>
                            <ModalFooter
                              onOk={() => MarkAsDelivered(uuid)}
                              onCancel={() => setShowModal(false)}
                            />
                          </Fragment>,
                        );
                      },
                    },
                  ]
                : []),
            ],
          }),
        };
      })}
    />
  );
};
export default ModalHoc(Delivery, { width: 500 });
